<div class="range-input">

  <form nz-form [formGroup]="form">

    <div nz-row nzGutter="16">
      <div
        nz-col
        nzSpan="12"
      >
        <nz-input-group
          [nzPrefix]="minPrefix"
          nzSize="small"
        >
          <input
            autocomplete="off"
            inputmode="numeric"
            [attr.id]="minId"
            nz-input
            [placeholder]="minPlaceholder"
            [mask]="mask"
            thousandSeparator="."
            formControlName="min"
            (keydown)="removeError()"
            (keypress)="isPositive($event)"
            (focus)="unset($event)"
            (blur)="blur('min')"
          />
        </nz-input-group>
      </div>

      <div
        nz-col
        nzSpan="12"
      >
        <nz-input-group
          [nzPrefix]="maxPrefix"
          nzSize="small"
        >
          <input
            autocomplete="off"
            inputmode="numeric"
            nz-input
            [attr.id]="maxId"
            [placeholder]="maxPlaceholder"
            [mask]="mask"
            thousandSeparator="."
            formControlName="max"
            (keydown)="removeError()"
            (keypress)="isPositive($event)"
            (focus)="unset($event)"
            (blur)="blur('max')"
          />
        </nz-input-group>
      </div>
    </div>

    <div *ngIf="form.hasError('notLesserThan')">
      <div class="ant-form-explain">
        <div class="text-danger">
          <img
            src="/assets/svgs/warning.svg"
            alt="icone de exclamação"
          >
          {{errorMessage}}
        </div>
      </div>
    </div>

  </form>

</div>
